// From HOME-340:  If the LO enters only digits (i.e. "278204"), we will
// prepend "NMLS #" to this and display "NMLS #278204."  Otherwise, we will just
// display whatever they enter (i.e. "NMLS #278204 / NMLS# 1016," "I like soup")
// without any prefix.

export const formatNMLS = (nmls) => {
  return nmls
    ? /^[0-9]+$/.test(nmls)
      ? `NMLS #${nmls}`
      : nmls
    : undefined
}
